<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table">
    <div class="row" style="margin-bottom: 10px;">
        <div class="col-12">
            <app-tab [tabs]="tabs" [(selectedKey)]="selectedTab" (onTabSelected)="onLoad()" (onRefresh)="onLoad()" />
        </div>
    </div>
    <div class="banner center" style="max-width:800px;">
        <div class="row row_header">
            <div class="col-2">
                {{localService.languageContent.table.ref_num}}
            </div>
            <div class="col-6">
                <label style="font-weight: normal; margin-left: 15px;">
                    <input type="checkbox" [(ngModel)]="isShowInactive" (change)="onLoad()" />
                    <span class="normal_color">&nbsp;</span>
                </label>
                {{localService.languageContent.table.title}}
            </div>
            <div class="col-4">
                <span>{{localService.languageContent.table.created_on}}</span>
                <button class="button_icon button_icon_color" style="float: right;"
                    title="{{localService.languageContent.common.add}}" (click)="onAction(1)">
                    note_add
                </button>
            </div>
        </div>
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
            <div class="row styled_row freeze_col"
                *ngFor="let item of (selectedTab == '1' ?  deviceItems : machineItems)">
                <div class="col-2">
                    <button class="button_icon button_icon_color icon_adjust" (click)="onRoute(item.key)"
                        *ngIf="selectedTab == '1'">display_settings</button>
                    <span class="en">&nbsp;{{item.v3}}</span>
                </div>
                <div class="col-6">
                    <button class="button_icon button_icon_color icon_adjust"
                        title="{{localService.languageContent.common.edit}}" (click)="onAction(2, item.key)">
                        edit
                    </button>
                    <span class="en">&nbsp;{{item.v1}}</span>
                </div>
                <div class="col-4">
                    <button class="button_icon button_icon_color icon_adjust" (click)="onAction(3,item.key)"
                        *ngIf="selectedTab == '1' && currentDeviceId != item.key">assignment_return</button>
                    <span class="en">&nbsp;{{item.v2 | date : 'dd-MMM-yyyy'}}</span>
                </div>
            </div>
        </div>
    </div>
    <app-config-ui-device [weightMachines]="weightMachineItems" [printers]="printers" [isOpenPopup]="isOpenDevicePopup"
        [id]="selectedDeviceId" [title]="selectedDeviceTitle" (onClose)="isOpenDevicePopup = false;onLoad();"
        [businessId]="businessId" />
    <app-config-machine [isOpenPopup]="isOpenMachinePopup" [id]="selectedMachineId" [title]="selectedMachineTitle"
        (onClose)="isOpenMachinePopup = false;onLoad();" [businessId]="businessId" />
</div>